import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }

import ProgressBar from './components/common/progress-bar/ProgressBar.vue';
import ToasterComponent from './components/common/toaster/ToasterComponent.vue';
import { CHANNEL_KEY, UseCaseKeyType } from './models/channel-keys';
import { CommandReceiver } from './utils/commands-reciever.utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const channel = new BroadcastChannel(CHANNEL_KEY);

channel.addEventListener('message', (event) => {
  const data = event.data as {
    useCase: UseCaseKeyType;
    aditionalInfo?: string;
    text: string;
  };

  CommandReceiver.Handle(data.useCase, data.text, data.aditionalInfo);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProgressBar),
    _createVNode(_component_router_view),
    _createVNode(ToasterComponent)
  ]))
}
}

})